import React from 'react';
import ReactDOM from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import Galeria from './screens/Galeria';
import Kontakt from './screens/Kontakt';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import NaszaHistoria from './screens/NaszaHistoria';
import Cennik from './screens/Cennik';

ReactDOM.render(
  <React.StrictMode>
    <HelmetProvider>
      <Router>
        <Routes>
          <Route path="/" element={<App />} />
          <Route path="/galeria" element={<Galeria />} />
          <Route path="/kontakt" element={<Kontakt />} />
          <Route path="/nasza_historia" element={<NaszaHistoria />} />
          <Route path="/cennik" element={<Cennik />} />
        </Routes>
      </Router>
    </HelmetProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
